import { NgModule } from '@angular/core';

import { PatientConsultationApiService } from './patient-consultation.service';

@NgModule({
    providers: [PatientConsultationApiService],
})
export class PatientConsultationApiModule {}

